export const TRIPS_STATUSES = ['primary', 'green', 'yellow']

export const INTRA_OPTIONS = [
    { id: 1, name: 'Да', value: '1' },
    { id: 2, name: 'Нет', value: '0' },
]
